<template>
  <grid
    :gridConfigUrl="gridConfigUrl" >
    <template slot="topSelectMenus"  slot-scope="props">
      <grid-menu-a
        @menu-click="updateAllInfo(props.ids)"
        name="设计"
        style="margin-right: 3px;"
        class="btn btn-hollow">
      </grid-menu-a>
    </template>
    <template slot="topNoSelectMenus">
      <grid-menu-a
        name="修改"
        style="margin-right: 3px;"
        class="btn btn-hollow">
      </grid-menu-a>
      <grid-menu-a
        name="IFRAME"
        url="https://www.baidu.com"
        target="mainContent"
        @menu-click="gotoIframe()"
        style="margin-right: 3px;"
        class="btn btn-hollow">
      </grid-menu-a>
    </template>

    <template slot="headerColumns">
      <li class="mTable-cell mTable-cell-medium">设置头像</li>
      <li class="mTable-cell mTable-cell-medium">修改信息</li>
    </template>
    <template slot="bodyColumns" slot-scope="props">
      <li class="mTable-cell mTable-cell-medium">
        <div class="mTable-cell-wrap">
          <span class="mTable-txt" >
            <grid-menu-a
              name="设置头像"
              url="https://www.baidu.com"
              target="_blank">
            </grid-menu-a>
          </span>
        </div>
      </li>
      <li class="mTable-cell mTable-cell-medium">
        <div class="mTable-cell-wrap">
          <span class="mTable-txt" >
            <grid-menu-a
              name="修改信息"
              @menu-click="updateInfo(props.row)">
            </grid-menu-a>
          </span>
        </div>
      </li>
    </template>
  </grid>
</template>
<script>
  import Grid from '../../../components/grid/grid.vue'
  import GridMenuA from '../../../components/grid-menu/grid-menu-a.vue'
  import {STORE_APP_MUTATION_TYPES} from '../../../libs/constants'
  export default {
    components: {
      Grid,
      GridMenuA
    },
    name: 'demo',
    data() {
      return {
        gridConfigUrl: ''
      }
    },
    computed: {
      gridConfigUrl: function () {
        return this.$route.meta.url
      }
    },
    created() {
      this.gridConfigUrl = this.$route.meta.url
    },
    methods: {
      updateInfo (row) {
        alert(row.id)
      },
      updateAllInfo (ids) {
        alert(ids)
      },
      gotoIframe () {
        this.$store.commit(STORE_APP_MUTATION_TYPES.SHOW_IFRAME)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/custom/components/grid/demo.vue